import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { LogOut } from "lucide-react";
import { Button } from "@/components/ui/atoms/Button";
import { createGTMTracking, getGTMAttributes } from "../../utils/gtm/gtm-tracking";
import { signupIntent } from "../../services/auth.service";

interface LogoutButtonProps {
  variant?: 'default' | 'mobile';
  /** Origin for GTM. */
  origin?: 'user_menu' | 'mobile_menu';
}

export const LogoutButton: React.FC<LogoutButtonProps> = ({ variant = 'default', origin = 'user_menu' }) => {
  const { logout } = useAuth0();

  const handleLogout = () => {
    // Wipe any cached signup intent so a re-login doesn't re-trigger
    // /api/onboarding/finalize for an old plan choice.
    signupIntent.clear();
    // Move the browser URL to "/" without triggering React Router. This
    // avoids the race where the Auth0 SDK clears local cache while we're
    // still on a protected route — ProtectedRouteWrapper would otherwise
    // bounce us to /login before Auth0's redirect to login-dev fires.
    window.history.replaceState(null, '', '/');
    logout({
      logoutParams: {
        // No trailing slash — Auth0 matches Allowed Logout URLs exactly.
        // Add `http://localhost:5173` (no slash) to that list in Auth0.
        returnTo: window.location.origin,
      },
    });
  };

  return (
    <Button
      label="Sign Out"
      type={variant === 'mobile' ? 'contained' : 'text'}
      intent="muted"
      size="sm"
      icon={<LogOut/>}
      className={variant === 'mobile' ? 'w-full' : undefined}
      onClick={handleLogout}
      {...getGTMAttributes(createGTMTracking('LOGOUT', { origin }))}
    />
  );
};
